import React from 'react';

const PortfolioPostSolution = () => {
    return (
        <section data-padding="top">
            <div className="stg-row stg-bottom-gap-l">
                <div className="stg-col-6 stg-tp-bottom-gap" data-appear="fade-right" data-unload="fade-left">
                    <h2>The Solution</h2>
                </div>
                <div className="stg-col-6 stg-tp-col-10 stg-tp-offset-2" data-appear="fade-left" data-unload="fade-right">
                    <p className="infocolors-large-text">The new Curology brand identity embodies the concept of "skin confidence." We designed a vibrant and dynamic logo that symbolizes personal growth and renewal. The color palette evokes both the warmth of human connection and the scientific precision of dermatology. The tone of voice is friendly, empowering, and informed, creating a genuine dialogue with customers.</p>
                </div>
            </div>
            <div className="infocolors-grid-3cols" data-stagger-appear="fade-up" data-stagger-unload="fade-left">
                <div>
                    <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio01/image02.jpg" alt="Curology" data-speed="0.95" data-m-speed="1" width="800" height="1200" />
                </div>
                <div>
                    <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio01/image03.jpg" alt="Curology" width="800" height="1200" />
                </div>
                <div>
                    <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio01/image04.jpg" alt="Curology" data-speed="1.05" data-m-speed="1" width="800" height="1200" />
                </div>
            </div>
        </section>
    );
};

export default PortfolioPostSolution;
